var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"therapy-record-container grid-content bg-purple"},[_c('div',{ref:"therapyRecordBar",staticClass:"therapy-record-bar",staticStyle:{"height":"384px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }